<script>
  export let question = '';
  export let answer = '';
  import iconChevron from '$lib/images/icon_chevron.svg';

  let isOpen = false;

  function toggleAccordion() {
    isOpen = !isOpen;
  }
</script>

<div class="flex flex-col gap-2.5">
  <div class={`flex flex-col px-3  border rounded-md transition-all duration-150 ${isOpen ? 'bg-white/10 border-white/20' : 'bg-white/10 border-transparent'}`}>
    <button class="flex items-center justify-between min-h-[45px] py-2.5" on:click={toggleAccordion}>
      <span class="text-[17px] leading-[23px] font-semibold text-white text-left">{question}</span>
      <img
        src={iconChevron}
        alt="arrow"
        class={`transform transition-transform duration-150 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
      />
    </button>
    {#if isOpen}
      <p class="text-[17px] leading-6 font-light text-white pb-3">
        {@html answer}
      </p>
    {/if}
  </div>
</div>
